import { createContext } from "react";

const context = createContext({
  dateRange: [null, null],
  setDateRange: () => {},
  selectedParty: [""],
  setSelectedParty: () => {},
  projectPartyData: {},
  projectPartyDataLoading: false,
  overviewFilterValue: "",
  setOverviewFilterValue: () => {},
  morphTableData: [],
  morphTableDataLoading: false,
  order: "",
  setOrder: () => {},
  orderBy: "",
  setOrderBy: () => {},
});

export default context;
